"use client"

import { useState, useEffect } from "react"
import { useRouter, useSearchParams } from "next/navigation"

export default function Login() {
  const [isLoading, setIsLoading] = useState(false)
  const router = useRouter()
  const searchParams = useSearchParams()
  const returnUrl = searchParams.get("returnUrl") || "/proposals"

  useEffect(() => {
    // Check if the user is already logged in
    const token = localStorage.getItem("token")
    if (token) {
      router.push(returnUrl)
    }
  }, [router, returnUrl])

  const handleGoogleLogin = () => {
    // Direct navigation - no CORS issues
    window.location.href = `/api/auth/google?returnUrl=${encodeURIComponent(returnUrl)}`
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <h2 className="block text-gray-700 text-sm font-bold mb-2">Login</h2>
        <button
          onClick={handleGoogleLogin}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="button"
          disabled={isLoading}
        >
          {isLoading ? "Loading..." : "Login with Google"}
        </button>
      </div>
    </div>
  )
}
